import { useEffect, useState } from 'react';
import Link from 'next/link';

import BlogImage from 'app/components/Blog/BlogImage';
import { GetParagraph, createMarkup } from 'app/scripts/utils';

import BlogDate from '../Blog/BlogDate';

import CloudinaryImage from './CloudinaryImage';

const BlogCards = ({
  item,
  shadow = true,
  rounded = true,
  bgWhite = true,
  userIconSize = 'lg',
  index,
}) => {
  const [subtitule, setSubTitule] = useState();
  useEffect(() => {
    setSubTitule(GetParagraph(item?.attributes?.body));
  }, []);

  return (
    <article>
      <div className="mb-3 group hover:transition-all">
        <div
          className={`text-left ${
            shadow ? 'shadow-md sm:shadow-lg' : ''
          } h-full rounded-[40px] ${rounded ? 'rounded-lg' : ''} ${
            bgWhite ? 'bg-white' : ''
          }`}
        >
          <Link
            href={item?.id ? '/blog/' + item?.attributes?.slug : '#'}
            passHref={true}
          >
            <BlogImage
              image_url={`${item?.attributes?.section1?.image?.data?.attributes?.url}`}
              alternativeText={`${item?.attributes?.section1?.image?.data?.attributes?.alternativeText}`}
              index={index}
            />
          </Link>

          <div className="lg:p-6 p-0 space-y-3 lg:mt-0 mt-4">
            <h6 className="lg:mb-2 mb-1 lg:text-[22px] text-[18px] font-[700] leading-tight">
              <Link
                href={item?.id ? '/blog/' + item?.attributes?.slug : '#'}
                passHref={true}
                className="text-[#00102B] hover:text-[#4152ee] leading-tight block"
              >
                {item?.attributes?.h1_black}
              </Link>
            </h6>
            <Link
              href={item?.id ? '/blog/' + item?.attributes?.slug : '#'}
              passHref={true}
            >
              {subtitule && (
                <p
                  className="line-clamp-2 lg:text-[16px] text-[14px] font-[400] text-[#383838] mb-2"
                  dangerouslySetInnerHTML={createMarkup(subtitule)}
                ></p>
              )}
              <div className="flex justify-between mb-3">
                <BlogDate date={item?.attributes?.section?.post_date} />
                <p className=" mt-1 text-[#716F6F] font-medium  text-[14px]">
                  {item?.attributes?.section1?.read_time}
                </p>
              </div>
              <div className="flex mb-5 items-center text-[14px] font-[500]">
                {item?.attributes?.banner?.auth_img?.data?.attributes?.url ? (
                  <CloudinaryImage
                    backendImgUrl={
                      item?.attributes?.banner?.auth_img?.data?.attributes?.url
                    }
                    className="rounded-[100%] object-cover w-[30px] h-[30px] mr-1"
                    alt={
                      item?.attributes?.banner?.auth_img?.data?.attributes
                        ?.alternativeText
                    }
                    type="icon"
                  />
                ) : item?.attributes?.section3?.avatar?.data?.attributes
                    ?.url ? (
                  <CloudinaryImage
                    backendImgUrl={
                      item?.attributes?.section3?.avatar?.data?.attributes?.url
                    }
                    className="rounded-[100%] object-cover w-[30px] h-[30px] mr-1"
                    alt={
                      item?.attributes?.section3?.avatar?.data?.attributes
                        ?.alternativeText
                    }
                    type="icon"
                  />
                ) : (
                  <CloudinaryImage
                    backendImgUrl={`/uploads/mdi_user_40d9164745_1eb2083113.svg`}
                    className="rounded-[100%] object-cover w-[30px] h-[30px] mr-1"
                    alt={`mdi_user_40d9164745_1eb2083113`}
                    type="icon"
                  />
                )}
                {item?.attributes?.section3?.title
                  ? item?.attributes?.section3?.title
                  : item?.attributes?.banner?.auth_name}
                {item?.attributes?.banner?.linkedin_link && (
                  <Link
                    href={`${item?.attributes?.banner?.linkedin_link}`}
                    className="inline-block"
                  >
                    <CloudinaryImage
                      backendImgUrl={`https://res.cloudinary.com/dthpnue1d/image/upload/c_fill,g_faces,w_140/c_scale,q_auto,f_auto,fl_lossy/mdi_linkedin_438c733644.svg`}
                      className="w-6 h-6 ml-1"
                      alt={`LinkDin`}
                      type="icon"
                    />
                  </Link>
                )}
              </div>
              <Link
                href={item?.id ? '/blog/' + item?.attributes?.slug : '#'}
                className="transition-custom9 transition-all border border-[#00102B] bg-[#FFFFFF] rounded-[4px] py-2 px-5 group-hover:bg-[#0050D5] group-hover:text-[#fff] group-hover:border-[#0050D5]"
              >
                Read More
              </Link>
            </Link>
          </div>
        </div>
      </div>
    </article>
  );
};

export default BlogCards;
